var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCalendarClash = function SvgCalendarClash(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "M3.833 2.937A.94.94 0 0 1 4.777 2a.94.94 0 0 1 .945.937v.937H9.5v-.937A.94.94 0 0 1 10.445 2a.94.94 0 0 1 .944.937v.937h1.417c.782 0 1.417.63 1.417 1.407v1.404H1V5.282c0-.776.634-1.406 1.415-1.406h1.418zm9.444 4.708c-2.647.238-4.722 2.447-4.722 5.136 0 1.744.874 3.285 2.207 4.219H2.417C1.634 17 1 16.37 1 15.594V7.625h12.28v.02zM18 12.781C18 15.11 16.096 17 13.75 17s-4.251-1.89-4.251-4.218c0-2.33 1.903-4.22 4.251-4.22 2.346 0 4.25 1.89 4.25 4.22zm-4.25 1.406a.67.67 0 0 0-.495.199.72.72 0 0 0-.214.504c0 .39.316.704.709.704a.67.67 0 0 0 .495-.2.72.72 0 0 0 .213-.504.73.73 0 0 0-.214-.503.68.68 0 0 0-.494-.2m.446-3.75a.456.456 0 0 0-.473-.468.49.49 0 0 0-.472.469v2.342c0 .259.239.47.472.47a.456.456 0 0 0 .472-.468z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCalendarClash);
export default ForwardRef;